export enum Rola {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_NAUCZYCIEL = 'ROLE_NAUCZYCIEL',
  ROLE_UCZEN = 'ROLE_UCZEN',
  ROLE_HELP_DESK = 'ROLE_HELP_DESK',
  ROLE_STUDENT = 'ROLE_STUDENT',
  ROLE_TESTER = 'ROLE_TESTER',
  ROLE_WDROZENIOWIEC = 'ROLE_WDROZENIOWIEC',
  ROLE_RODZIC = 'ROLE_RODZIC',
  ROLE_EDYTOR = 'edytor',
  ROLE_NADZORCA = 'ROLE_NADZORCA'
}
export enum RolaWdrozenia {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_NAUCZYCIEL = 'ROLE_NAUCZYCIEL',
  ROLE_UCZEN = 'ROLE_UCZEN',
  ROLE_HELP_DESK = 'ROLE_HELP_DESK',
  ROLE_STUDENT = 'ROLE_STUDENT',
  ROLE_TESTER = 'ROLE_TESTER',
  ROLE_WDROZENIOWIEC = 'ROLE_WDROZENIOWIEC',
  ROLE_RODZIC = 'ROLE_RODZIC',
  ROLE_NADZORCA = 'ROLE_NADZORCA'
}
